<script setup>
    import { useRoute } from 'vue-router';
    import { useStageStore } from '@/stores/stage';
    import { useI18n } from 'vue-i18n'

    const route = useRoute();
    const formStorage = useStageStore();
    const { t } = useI18n()


    const handleMapToggle = (routeID) => {
        // mapToggle
        formStorage.toggleMap()

        if(formStorage.showMap){
            setTimeout(() => {
                document.querySelector('.survey-map')?.classList.remove('opacity-0')
                document.querySelector(`#map-dot-${routeID}`).focus({preventScroll: true})
            }, 200);
        }
    }
</script>

<template>
    <button @click="handleMapToggle(route.params.id)" type="button" class="toggle-map" :title="t('button.toggle-map')">
        <span class="toggle-button--icon">
            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.608 21.608">
                <path d="M15.443 13.59h-.976l-.346-.334a8.043 8.043 0 1 0-.865.865l.334.346v.976l6.177 6.165 1.841-1.841Zm-7.413 0a5.56 5.56 0 1 1 5.56-5.56 5.552 5.552 0 0 1-5.56 5.56Z" fill="#fff"/>
            </svg> -->

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.935 16.935">
              <path d="m16.465 0-.151.028-5.024 1.948L5.645 0 .339 1.788A.474.474 0 0 0 0 2.239v14.226a.466.466 0 0 0 .47.47l.151-.028 5.024-1.948 5.645 1.976 5.31-1.787a.474.474 0 0 0 .339-.452V.47a.466.466 0 0 0-.474-.47ZM11.29 15.053l-5.645-1.985V1.882l5.645 1.985Z" fill="#fff"/>
            </svg>
        </span>
        <span class="toggle-button--text" style="width: 100%; font-size: .95rem; margin-top: 0.25rem;">
            {{ $t('button.toggle-map') }}
        </span>
    </button>
</template>